<script setup lang="ts">
/**
 * A rule, or a measured gap.
 *
 * The gap is real white space in the printed document, not a placeholder: a
 * page sometimes needs air between two things, and forcing somebody to fake it
 * with an empty paragraph produces something that breaks differently in
 * export.
 */
import type { DividerSection } from '@/domain/section'

defineProps<{ section: DividerSection }>()
</script>

<template>
  <hr v-if="section.variant === 'rule'" class="divider" />
  <div v-else class="divider__space" :style="{ height: `${section.space}mm` }" aria-hidden="true" />
</template>

<style scoped>
.divider {
  height: 0;
  margin: 1.2em 0;
  border: 0;
  border-top: 1px solid var(--page-accent);
  opacity: 0.55;
}
</style>
